// extracted by mini-css-extract-plugin
export default {"buttonBoxWidget":"ButtonBoxDashboardWidget_buttonBoxWidget__2nNCK"};